<template>
  <div>
    <ca-heading text="Cálculo de férias em grupo" />

    <ca-row v-if="!isValidPeriod && boxInformationPeriodInfo">
      <ca-col>
        <ca-box-information :alert.sync="boxInformationPeriodInfo"></ca-box-information>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="3">
        <div v-ca-tooltip="calculateButtonTooltipMessage">
          <ca-button
            theme="secondary"
            :disabled="!isValidPeriod"
            @click="onAddRelease">
            Adicionar lançamentos
          </ca-button>
        </div>
      </ca-col>
    </ca-row>

    <ca-page class="ca-u-margin-top">
      <ca-form
        :key="formKey"
        :on-submit="onSubmit"
        :on-submit-success="onCalculateResolved"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col>
            <ca-box-information
              :alert.sync="boxInformationDisregardedDates">
            </ca-box-information>
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col>
            <ca-box-information
              :alert.sync="boxInformationErrorMessage">
            </ca-box-information>
          </ca-col>
        </ca-row>
        <br />
        <ca-row>
          <ca-col size="12" class="ca-u-min-margin-top">
            <p class="ca-u-no-margin-top ca-u-no-margin-bottom">
              Calcule as férias coletivas dos funcionários em grupo, antes, verifique as
              condições/regras de acordo com cada situação.
              <ca-link @click="openVacationRoles">
                Acesse o link e veja os detalhes
              </ca-link>
            </p>
          </ca-col>
        </ca-row>
        <br />
        <ca-row>
          <ca-col size="6">
            <stocking-select
              v-model="groupCalculation.lotacao"
              :show-all="true"
              required></stocking-select>
          </ca-col>
          <ca-col size="6">
            <job-description-select
              v-model="groupCalculation.funcao"
              :show-all="true"
              required></job-description-select>
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col size="9">
            <ca-row>
              <ca-col size="3">
                <ca-field label="Data de saída">
                  <ca-date-input
                    v-model="groupCalculation.dtSaida"
                    required>
                  </ca-date-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Dias de férias">
                  <ca-input
                    v-model="groupCalculation.qntDias"
                    min="1"
                    max="99999"
                    type="number"
                    @change="onDaysChange"></ca-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Data do Fim">
                  <ca-date-input
                    v-model="groupCalculation.endDate"
                    required
                    disabled>
                  </ca-date-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Data do retorno">
                  <ca-date-input
                    v-model="groupCalculation.dtRetorno"
                    required
                    disabled>
                  </ca-date-input>
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row>
              <ca-col size="3">
                <ca-field label="Data do pagamento">
                  <ca-date-input
                    v-model="groupCalculation.dtPagamento"
                    required
                    :on-change="checkPeriod">
                  </ca-date-input>
                </ca-field>
              </ca-col>
            </ca-row>
          </ca-col>
          <ca-col size="3">
            <disregarded-date-input
              :vacation-leaving-date="groupCalculation.dtSaida"
              :vacation-days="parseInt(groupCalculation.qntDias)"
              :disregarded-dates="groupCalculation.disregardedDates"
              @change="updateDisregardedDates">
            </disregarded-date-input>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <div v-ca-tooltip="calculateButtonTooltipMessage">
                <ca-submit-button :disabled="!isValidPeriod">
                  Salvar
                </ca-submit-button>
              </div>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import {
  getBoxInformationCalculationMessageError,
} from 'packages/common/utils';
import { checkPeriodMixin } from 'packages/common/mixins/check-period/CheckPeriodMixin.js';
import { EmployerStore } from 'accountant/employer/store';
import { getStockings, setStockings } from 'accountant/employer/stockings/stockingService';
import {
  getJobDescriptions,
  setJobDescriptions,
} from 'accountant/employer/job-descriptions/jobDescriptionService';
import VacationRolesModal from 'accountant/payroll/src/modules/vacations/modals/VacationRolesModal';
import {
  groupVacationCalculation,
  getReturnDate,
  getPaymentDate,
  getEndDate,
  validateDisregardedDates,
  getBoxInformationDisregardedDates,
} from './vacationsService';
import AddReleaseModal from './modals/AddReleaseModal';
import RecalculateModal from '../../components/RecalculateModal';
import { PayrollStore } from '../../store';
import DisregardedDateInput from './components/DisregardedDateInput';
import { DISREGARDED_DATES_ERROR } from './constants';

export default {
  name: 'VacationsGroupFormPage',
  components: {
    DisregardedDateInput,
  },
  mixins: [checkPeriodMixin({ initialCheck: false })],
  data() {
    return {
      formKey: 0,
      groupCalculation: {
        lotacao: null,
        funcao: null,
        movimentos: [],
        indNovoPerAq: 'false',
        disregardedDates: [],
      },
      errorMessage: null,
      boxInformationDisregardedDates: null,
      boxInformationErrorMessage: null,
    };
  },
  computed: {
    totalDays() {
      return this.groupCalculation.qntDias;
    },
    stockings() {
      return EmployerStore.stockings;
    },
    jobDescriptions() {
      return EmployerStore.jobDescriptions;
    },
    initialVacationDate() {
      return this.groupCalculation.dtSaida;
    },
    calculateButtonTooltipMessage() {
      return this.isValidPeriod
        ? ''
        : 'Você está dentro de um período fechado e não é possível realizar o cálculo';
    },
    saveButtonTooltipMessage() {
      return this.isValidPeriod
        ? ''
        : 'Você está dentro de um período fechado e não é possível realizar este lançamento';
    },
    hasVacations() {
      return PayrollStore.vacations.length > 0;
    },
  },
  watch: {
    initialVacationDate() {
      this.groupCalculation.dtPagamento = getPaymentDate(this.groupCalculation.dtSaida);
    },
  },
  created() {
    this.initData();
  },
  methods: {
    refreshForm() {
      this.formKey++;
    },
    initData() {
      this.getStockings();
      this.getJobDescriptions();
    },
    checkPeriod() {
      this.checkPeriodValidation(this.groupCalculation.dtPagamento);
    },
    onDaysChange() {
      const { dtSaida: leavingDate, qntDias, disregardedDates } = this.groupCalculation;

      if (leavingDate) {
        const days = disregardedDates.length + parseInt(qntDias);
        this.$set(this.groupCalculation, 'dtRetorno', getReturnDate(leavingDate, days));
        this.$set(this.groupCalculation, 'endDate', getEndDate(this.groupCalculation.dtRetorno, 1));
      }
    },
    async getStockings() {
      const response = await getStockings();
      setStockings(response);
    },
    async getJobDescriptions() {
      const response = await getJobDescriptions();
      setJobDescriptions(response.content);
    },
    goBack() {
      this.$router.push({ name: 'VacationPage' });
    },
    openRecalculateModal() {
      return new Promise(res => {
        this.$dialogModal(RecalculateModal, {
          props: { title: 'Cálculo de férias em grupo' },
          on: {
            confirm: () => res(groupVacationCalculation(this.groupCalculation)),
            cancel: () => res({ cancelCalculate: true }),
          },
        }).open();
      });
    },
    onSubmit() {
      this.boxInformationDisregardedDates = null;
      this.boxInformationErrorMessage = null;
      const { disregardedDates, dtSaida, qntDias } = this.groupCalculation;
      if (!validateDisregardedDates(disregardedDates, dtSaida, qntDias)) {
        return Promise.reject(new Error(DISREGARDED_DATES_ERROR));
      }

      if (this.hasVacations) {
        return this.openRecalculateModal();
      }

      return groupVacationCalculation(this.groupCalculation);
    },
    onCalculateResolved({ cancelCalculate }) {
      if (!cancelCalculate) {
        this.onSubmitSuccess();
      }
    },
    onSubmitSuccess() {
      this.goBack();
      this.$toaster.success('Dados salvos com sucesso');
    },
    onSubmitError(error) {
      if (error.message === DISREGARDED_DATES_ERROR) {
        this.boxInformationDisregardedDates = getBoxInformationDisregardedDates();
      } else {
        this.boxInformationErrorMessage = getBoxInformationCalculationMessageError(error);
      }
    },
    onAddRelease() {
      this.$dialogModal(AddReleaseModal, {
        props: {
          movements: this.groupCalculation.movimentos,
        },
        on: {
          'update-movements': movements => this.$set(this.groupCalculation, 'movimentos', movements),
        },
      }).open();
    },
    updateDisregardedDates(disregardedDates) {
      this.$set(this.groupCalculation, 'disregardedDates', disregardedDates);
      const days = disregardedDates.length + parseInt(this.groupCalculation.qntDias);
      const returnDate = getReturnDate(this.groupCalculation.dtSaida, days);
      this.$set(this.groupCalculation, 'dtRetorno', returnDate);
      this.$set(this.groupCalculation, 'endDate', getEndDate(returnDate, 1));
    },
    openVacationRoles() {
      this.$dialogModal(VacationRolesModal).open();
    },
  },
};
</script>
